module.exports = __webpack_public_path__ + "name=img/src/assets/projects/code/yandex-test-task/2.png?2be4e743cbdf1bc07dea249488e66f0d";